<div *ngIf="movies?.length > 0" class="swiper-carousel ">

    <!-- titulo -->
    <h2 class="text-white font_CinematecaBlack fs-4 ml-3 ml-lg-5 mb--30">{{title}}</h2>

    <swiper [config]="swiperConfig" [(index)]="swiperIndex" [class.noBorderSwiper]="noBorders">
        <div swiperSlide class="movie-item-card" *ngFor="let movie of movies">
            <app-ui-movie class="movie-item" [useHover]="false" [movie]="movie"></app-ui-movie>
        </div>
    </swiper>
</div>